'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
  onScrollToId?: (id: string) => void;
}

const tieuchi = [
'thái độ tốt, tinh thần trách nhiệm cao',
'hình ảnh cá nhân phù hợp với tinh thần trẻ, tích cực, chân thật',
'khả năng chia sẻ và kết nối cộng đồng ở mức phù hợp',
'mong muốn đồng hành lâu dài thay vì chỉ tham gia ngắn hạn',
'sự nghiêm túc trong cách làm việc và cách đại diện hình ảnh'];


const quyenloi = [
'được công nhận là Student Ambassador của Tri An Green Travel',
'được ưu tiên tham gia các chương trình, hoạt động và trải nghiệm tiếp theo',
'được rèn luyện thêm kỹ năng truyền thông, kết nối cộng đồng, tổ chức hoạt động và xây dựng hình ảnh cá nhân',
'được ưu tiên xuất hiện trong các nội dung truyền thông chính thức nếu phù hợp',
'được áp dụng chính sách ưu đãi riêng khi sử dụng các sản phẩm, dịch vụ trong hệ sinh thái Trị An Holding',
'có cơ hội nhận ghi nhận dưới hình thức ưu đãi, quà tặng, hiện vật, credit hoặc hỗ trợ phù hợp theo từng giai đoạn',
'có cơ hội được cân nhắc cho các vai trò cộng tác dài hạn nếu phù hợp'];


export default function Slide24Role({ id, registerRef, onScrollToId }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1cea8da1e-1772094672439.png"
          alt="Tình nguyện viên trẻ làm việc cùng nhau trong thiên nhiên xanh"
          className="w-full h-full object-cover opacity-8" />
        
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1a0f]/95 via-[#1a3a2a]/70 to-[#0a1a0f]/95" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-16 min-h-screen flex flex-col justify-center">
        {/* Header */}
        <div className="fade-in-up mb-8 text-center">
          <p className="font-display font-600 text-[clamp(11px,1.4vw,14px)] text-[#4caf7d] uppercase tracking-[0.15em] mb-2">
            Student Ambassador
          </p>
          <h2 className="font-display font-800 text-[clamp(22px,3.5vw,44px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Tiêu chí lựa chọn & Quyền lợi
          </h2>
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#4caf7d] to-[#a8d87a] rounded-full mx-auto mt-4" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-7 fade-in-up">
          {/* Left: Tiêu chí */}
          <div className="rounded-2xl border border-[rgba(76,175,125,0.25)] bg-[rgba(76,175,125,0.06)] p-7">
            <h3 className="font-display font-700 text-[17px] text-[#4caf7d] mb-2">Tiêu chí lựa chọn</h3>
            <p className="font-body text-[13px] text-[#a0b8a8] leading-relaxed mb-5">
              Tri An Green Travel ưu tiên lựa chọn những bạn có:
            </p>
            <ul className="space-y-3">
              {tieuchi.map((item, i) =>
              <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-[rgba(76,175,125,0.2)] border border-[rgba(76,175,125,0.4)] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#4caf7d" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                  </div>
                  <span className="font-body text-[13px] text-[#c0d8c0] leading-relaxed">{item}</span>
                </li>
              )}
            </ul>
          </div>

          {/* Right: Quyền lợi */}
          <div className="rounded-2xl bg-[#1a4a2a] p-7 flex flex-col">
            <h3 className="font-display font-700 text-[17px] text-white mb-2">Quyền lợi dành cho Student Ambassador</h3>
            <p className="font-body text-[13px] text-white/75 leading-relaxed mb-5">
              Khi trở thành Student Ambassador, sinh viên có thể nhận được các quyền lợi phù hợp như:
            </p>
            <ul className="space-y-2.5 flex-1">
              {quyenloi.map((item, i) =>
              <li key={i} className="flex items-start gap-2.5">
                  <span className="text-[#a8d87a] font-700 text-[14px] flex-shrink-0 mt-0.5">—</span>
                  <span className="font-body text-[12px] text-white/85 leading-relaxed">{item}</span>
                </li>
              )}
            </ul>

            {onScrollToId &&
            <button
              onClick={() => onScrollToId('slide-25')}
              className="mt-6 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-white/15 border border-white/25 text-white font-display font-600 text-[12px] hover:bg-white/25 transition-colors">
              
                Xem thêm — Chính sách ưu đãi
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12l7 7 7-7" /></svg>
              </button>
            }
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-4 border-t border-[rgba(76,175,125,0.1)] flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up">
          <span className="font-body text-[11px] text-[#a0b8a8]/60 uppercase tracking-wider">HOTLINE: 0827092079</span>
          <span className="hidden sm:block text-[#a0b8a8]/30">|</span>
          <span className="font-body text-[11px] text-[#a0b8a8]/60 uppercase tracking-wider">EMAIL: triangreentravel@gmail.com</span>
        </div>
      </div>
    </SlideWrapper>);

}